export default function Splash() {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: '#0f172a',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: 120,
          height: 120,
          backgroundColor: '#000',
          borderRadius: 20,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 16,
          overflow: 'hidden',
        }}
      >
        <img src="/icons/icon-512.png" alt="" style={{ width: 100, height: 100, objectFit: 'contain' }} />
      </div>
      <div style={{ color: '#f8fafc', fontSize: 32, fontWeight: 900, letterSpacing: 2 }}>AGA</div>
      <div style={{ color: '#64748b', fontSize: 14, fontWeight: 500, marginTop: 4 }}>All Game Arena</div>
      <div
        style={{
          marginTop: 32,
          width: 36,
          height: 36,
          border: '4px solid rgba(20, 184, 166, 0.25)',
          borderTopColor: '#14b8a6',
          borderRadius: '50%',
          animation: 'aga-spin 1s linear infinite',
        }}
      />
      <style>{`@keyframes aga-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
